export default __webpack_public_path__ + "static/media/logo.1717a1bc.png";